import type { SimpleButtonProps } from 'components/common/buttons/SimpleButton/types';

import {
    buttonInnerTextFontWeight,
    buttonInnerTextFontSize,
    buttonBorderRadius,
    buttonPadding
} from 'components/common/buttons/SimpleButton/constants';
import { PURPLE_60, GRAY_80, ORANGE, WHITE } from 'ui-kit/GlobalStyle/colors';
import { disableDefaultButtonStyleMixin } from 'constants/styles/mixins';
import styled, { css } from 'styled-components';
import media from 'utils/media-query';

import whitePlusIcon from './static_assets/white_plus_icon.svg';
import bluePlusIcon from './static_assets/blue_plus_icon.svg';

// TODO: make this govno with css classes
export const generateHoverMixin = (color: string) => css`
    &:hover {
        background-color: ${WHITE};
        color: ${color};
        border: 1px solid ${color};
    }
`;

export const generateClickedMixin = (color: string) => css`
    &:active {
        background-color: ${color};
    }
`;

export const supportHoverMixin = css`
    &:hover {
        background-color: ${PURPLE_60};
        color: ${WHITE};
        border: 1px solid ${WHITE};
    }
`;

// TODO: !important
export const defaultDisabledMixin = css`
    color: ${WHITE} !important;
    background-color: ${GRAY_80} !important;
    border-color: ${GRAY_80} !important;
    cursor: default;
`;

export const StyledSimpleButton = styled.button<SimpleButtonProps>`
    ${disableDefaultButtonStyleMixin};
    ${({ width }) => width && `width: ${width}`};
    ${({ minWidth }) => minWidth && `min-width: ${minWidth}`};
    ${({ height }) => height && `height: ${height}`};
    ${({ marginRight }) => marginRight && `margin-right: ${marginRight}`};
    font-size: ${({ fontSize }) => fontSize || buttonInnerTextFontSize};
    font-weight: ${({ fontWeight }) => fontWeight || buttonInnerTextFontWeight};
    color: ${({ color }) => color || 'white'};
    background-color: ${({ backgroundColor }) => backgroundColor || PURPLE_60};
    border-radius: ${({ borderRadius }) => borderRadius || buttonBorderRadius};
    border-style: solid;
    border-width: 1px;
    border-color: ${({ backgroundColor }) => backgroundColor || PURPLE_60};
    ${({ border }) => border && `border: ${border}`};
    padding: ${({ padding }) => padding || buttonPadding};
    ${({ paddingLeft }) => paddingLeft && `padding-left: ${paddingLeft}`};
    ${({ paddingRight }) => paddingRight && `padding-right: ${paddingRight}`};
    ${({ disabled }) => disabled && defaultDisabledMixin};
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    white-space: nowrap;
    transition-duration: 0.2s;
    ${({ hideSvgOnHover }) =>
        hideSvgOnHover &&
        `
            &:hover {
                img {
                    visibility: hidden;
                }
            }
        `}

    ${({ styleType }) => {
        switch (styleType) {
            case 'primary':
                return css`
                    ${generateHoverMixin(PURPLE_60)};
                    ${generateClickedMixin('#380782')};
                `;

            case 'secondary':
                return css`
                    ${generateHoverMixin(ORANGE)};
                    ${generateClickedMixin('#D15F2E')};
                `;

            case 'support':
                return css`
                    ${supportHoverMixin};
                    ${generateClickedMixin('#380782')};
                `;

            case 'add':
                return css`
                    background-image: url(${whitePlusIcon});
                    background-position: center;
                    background-repeat: no-repeat;

                    &:hover {
                        background-image: url(${bluePlusIcon});
                    }

                    &:active {
                        background-image: url(${whitePlusIcon});
                    }
                `;
        }
    }}

    ${media.desktopLg`
        font-size: 16px;
    `}

    ${media.desktop`
        font-size: 14px;
    `}

    ${media.tablet`
        font-size: 12px;
    `}
`;
